
import axios from 'axios';
import cookies from 'vue-cookies';
import router from '@/router';

import Generate from '@/lib/genThresh';

import Helper from '@/lib/langTemplates/HelperClauses';

const baseUrl = 'https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/';

const Setpoints = {

  state: {
    activeDeviceSetpoint: {}
  },

  getters: {},

  actions: {

    async postNewSp(context, sp){
      const params = {
        method: 'POST',
        url: `${baseUrl}setpoint/${sp.did}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: cookies.get('breeziProTkn')
        },
        data: JSON.stringify(sp.data)
      };
      try {
        await axios(params);
        context.dispatch('refreshRoom', sp.did);
        context.dispatch('initNotif', {
          type: 'notif',
          title: Helper.clauses.spUpdate[`${context.rootState.lang}Title`],
          body: Helper.clauses.spUpdate[context.rootState.lang]
        });
      } catch(err) {
        console.log(err);
        context.dispatch('initNotif', {
          type: 'err',
          title: Helper.clauses.spUpdateFail[`${context.rootState.lang}Title`],
          body: Helper.clauses.spUpdateFail[context.rootState.lang]
        });
      }
    },

    async resetSp(context, did){
      const params = {
        method: 'DELETE',
        url: `${baseUrl}setpoint/${did}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: cookies.get('breeziProTkn')
        }
      }
      try {
        await axios(params);
        context.dispatch('refreshRoom', did);
        context.commit('setDefaultSP', did);
        context.dispatch('initNotif', {
          type: 'notif',
          title: Helper.clauses.spReset[`${context.rootState.lang}Title`],
          body: Helper.clauses.spReset[context.rootState.lang]
        });
      } catch(err) {
        console.log(err);
        context.dispatch('initNotif', {
          type: 'err',
          title: Helper.clauses.spUpdateFail[`${context.rootState.lang}Title`],
          body: Helper.clauses.spUpdateFail[context.rootState.lang]
        });
      }
    }

  }

}

function compileFullSP(sp){
  let template = Generate;
  if (!sp || sp === undefined || ['days', 'ttp', 'hhm', 'iaq', 'co2'].every(i => !sp[i])) {
    return template;
  } else {
    Object.keys(sp).forEach(i => {
      if (i !== 'deviceId') {
        ['bad', 'bad2', 'crit', 'crit2', 'good'].forEach(x => {
          if (sp[i][x]) {
            template[i][x] = sp[i][x];
          }
        });
      }
    })
  }
  return template;
}

export default Setpoints;



// WEBPACK FOOTER //
// ./src/store/setpoints.js